/* LAYALA product builder: offer tiers, per-piece colour + size, gift note, add to cart. */
(function () {
  var ORD = { 2: 'الثانية', 3: 'الثالثة', 4: 'الرابعة', 5: 'الخامسة' };
  var T = {
    piece: 'القطعة',
    add: 'أضيفي إلى السلة',
    chooseSize: 'اختاري المقاس أولًا',
    chooseAll: 'اختاري المقاس لكل قطعة',
    gift: 'بطاقة إهداء'
  };
  var money = function (c) { return window.LY && LY.money ? LY.money(c) : (c / 100) + ''; };
  var esc = function (s) { return String(s).replace(/[&<>\"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  /* "مولود جديد 0-3 سنين" -> name on top, age range under it (values may carry an LRM before the digits so ranges read correctly in RTL) */
  var fmt = function (s) {
    var m = String(s).trim().match(/^(.*\S)\s+[‎⁦]?(\d+\s*[-–]\s*\d+\s*\S*)$/);
    return m ? '<b>' + esc(m[1]) + '</b><small>' + esc(m[2]) + '</small>' : '<b>' + esc(s) + '</b>';
  };
  /* products without a size choice (one variant) need no picking per piece */
  var onlyVid = function (p) { return p && p.variants.length === 1 ? p.variants[0].id : null; };

  document.querySelectorAll('[data-ly-product]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-ly-pdata]').textContent);
    var products = data.products.length ? data.products : [];
    var byId = function (id) { return products.find(function (p) { return p.id === id; }) || products[0]; };
    var current = byId(data.current);
    var tiers = (data.offer && data.offer.tiers) || [];
    var state = { tier: 1, size: null, pieces: [] };
    if (current && current.variants.length === 1) state.size = current.variants[0].id;

    root.querySelectorAll('[data-ly-size]').forEach(function (b) {
      var t = b.textContent.trim();
      b.dataset.label = t;
      b.innerHTML = fmt(t);
    });

    var tierTotal = function (n) {
      if (n === 1 || !tiers.length) return current.price * n;
      var t = tiers.filter(function (x) { return x.units <= n; }).sort(function (a, b) { return b.units - a.units; })[0];
      if (!t) return current.price * n;
      return (t.total + (n - t.units) * (data.offer.extra_unit || 0)) * 100;
    };

    var piecesBox = root.querySelector('[data-ly-pieces]');
    var singleBox = root.querySelector('[data-ly-single]');
    var errEls = root.querySelectorAll('[data-ly-err]');
    var btns = root.querySelectorAll('[data-ly-add]');
    var showErr = function (msg) { errEls.forEach(function (e) { e.textContent = msg || ''; e.hidden = !msg; }); };

    var label = function () {
      var total = state.tier > 1 ? tierTotal(state.tier) : current.price;
      btns.forEach(function (b) { var s = b.querySelector('[data-ly-btn-text]'); if (s) s.textContent = T.add + ' · ' + money(total); });
    };

    var renderPieces = function () {
      if (!piecesBox) return;
      piecesBox.hidden = state.tier === 1;
      if (singleBox) singleBox.hidden = state.tier > 1;
      if (state.tier === 1) { piecesBox.innerHTML = ''; return; }
      while (state.pieces.length < state.tier) state.pieces.push({ pid: current.id, vid: onlyVid(current) });
      state.pieces.length = state.tier;
      piecesBox.innerHTML = state.pieces.map(function (pc, i) {
        var p = byId(pc.pid);
        var v = p.variants.find(function (x) { return x.id === pc.vid; });
        var sw = products.length > 1 ? '<div class="ly-swatches" style="margin-bottom:12px">' + products.map(function (q) {
          return '<button type="button" class="ly-swatch ly-swatch--sm' + (q.id === p.id ? ' is-current' : '') + '" data-i="' + i + '" data-pid="' + q.id + '" aria-label="' + T.piece + ' ' + (i + 1) + ': ' + esc(q.label) + '"><span class="ly-sw--' + q.finish + '"></span></button>';
        }).join('') + '</div>' : '';
        var sizes = p.variants.length > 1 ? '<div class="ly-sizes">' + p.variants.map(function (x) {
          return '<button type="button" class="ly-size ly-size--sm' + (x.id === pc.vid ? ' is-active' : '') + '" data-i="' + i + '" data-vid="' + x.id + '"' + (x.available ? '' : ' disabled') + '>' + fmt(x.size) + '</button>';
        }).join('') + '</div>' : '';
        return '<div class="ly-piece"><p><b>' + T.piece + ' ' + (i + 1) + ':</b> <span>' + esc(p.label) + (v && p.variants.length > 1 ? ' · ' + esc(v.size) : '') + '</span></p>' + sw + sizes + '</div>';
      }).join('');
    };

    root.addEventListener('change', function (e) {
      if (e.target.name === 'ly-tier') {
        state.tier = Number(e.target.value);
        root.querySelectorAll('.ly-tier').forEach(function (l) { l.classList.toggle('is-active', l.contains(e.target)); });
        showErr('');
        renderPieces();
        label();
      }
    });

    root.addEventListener('click', function (e) {
      var sz = e.target.closest('[data-ly-size]');
      if (sz && !sz.disabled) {
        state.size = Number(sz.dataset.variant);
        root.querySelectorAll('[data-ly-size]').forEach(function (b) { b.classList.toggle('is-active', b === sz); });
        var sl = root.querySelector('[data-ly-size-label]'); if (sl) sl.textContent = sz.dataset.label || sz.textContent;
        showErr('');
        return;
      }
      var sw = e.target.closest('[data-pid]');
      if (sw && piecesBox && piecesBox.contains(sw)) {
        var i = Number(sw.dataset.i);
        var np = byId(Number(sw.dataset.pid));
        state.pieces[i] = { pid: np.id, vid: onlyVid(np) };
        renderPieces();
        return;
      }
      var pv = e.target.closest('[data-vid]');
      if (pv && piecesBox && piecesBox.contains(pv) && !pv.disabled) {
        state.pieces[Number(pv.dataset.i)].vid = Number(pv.dataset.vid);
        showErr('');
        renderPieces();
        return;
      }
      var thumb = e.target.closest('[data-ly-thumb]');
      if (thumb) {
        var slide = root.querySelector('[data-ly-slide="' + thumb.dataset.lyThumb + '"]');
        if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        root.querySelectorAll('[data-ly-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        return;
      }
      var add = e.target.closest('[data-ly-add]');
      if (add) {
        var items = [];
        if (state.tier === 1) {
          if (!state.size) { showErr(T.chooseSize); var sp = root.querySelector('[data-ly-single]'); if (sp) sp.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          items.push({ id: state.size, quantity: 1 });
        } else {
          if (state.pieces.some(function (pc) { return !pc.vid; })) { showErr(T.chooseAll); piecesBox.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          state.pieces.forEach(function (pc) { items.push({ id: pc.vid, quantity: 1 }); });
        }
        var giftOn = root.querySelector('[data-ly-gift-on]');
        var giftText = root.querySelector('[data-ly-gift-text]');
        if (giftOn && giftOn.checked && giftText && giftText.value.trim()) { items[0].properties = {}; items[0].properties[T.gift] = giftText.value.trim(); }
        btns.forEach(function (b) { b.disabled = true; });
        LY.addItems(items).catch(function (er) { showErr(er.message); }).finally(function () { btns.forEach(function (b) { b.disabled = false; }); });
      }
    });

    var gOn = root.querySelector('[data-ly-gift-on]');
    if (gOn) gOn.addEventListener('change', function () { var box = root.querySelector('[data-ly-gift-box]'); if (box) box.hidden = !gOn.checked; });
    var gTx = root.querySelector('[data-ly-gift-text]');
    if (gTx) gTx.addEventListener('input', function () { var c = root.querySelector('[data-ly-gift-count]'); if (c) c.textContent = gTx.value.length; });
    label();
  });
})();
